//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'NaRevise',
  data () {
    return {
      form: {
        measureBlood: '',
        triglyceride: ''
      },
      urea: 'urea_bun',
      hasScore: false,
      disabled: false,
      bun_value: '',
      descTxt: ''
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      console.log(self.form)
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }

      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        let result = form.measureBlood + form.triglyceride * 0.2
        console.log(form, result, 'result')
        self.hasScore = true
        if (result < 35) {
          self.descTxt = '肾前性可能'
        }
        return String(result.toFixed(2))
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Renal/NaRevise.vue